import LivroCaixaPage from './pages/LivroCaixaPage';
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import AdminPage from './pages/AdminPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import TiposPage from './pages/TiposPage';
import HistoricoPage from './pages/HistoricoPage';
import CadastroPage from './pages/CadastroPage';
import SuperAdminPage from './pages/SuperAdminPage';
import EmprestimosPage from './pages/EmprestimosPage';
import AjudaPage from './pages/AjudaPage';
import EsqueciSenhaPage from './pages/EsqueciSenhaPage';
import RedefinirSenhaPage from './pages/RedefinirSenhaPage';
import Layout from './components/Layout';

function PrivateRoute({ children }) {
  const { user, profile, loading } = useAuth();
  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh' }}>
      <div className="spinner" style={{ width:32, height:32 }} />
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (profile?.must_change_password) return <Navigate to="/change-password" replace />;
  return children;
}

function AdminRoute({ children }) {
  const { user, profile, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (profile?.must_change_password) return <Navigate to="/change-password" replace />;
  if (profile?.role !== 'admin') return <Navigate to="/" replace />;
  return children;
}

function SuperAdminRoute({ children }) {
  const { user, profile, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!profile?.is_super_admin) return <Navigate to="/" replace />;
  return children;
}

function ChangePasswordRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/cadastro" element={<CadastroPage />} />
            <Route path="/esqueci-senha" element={<EsqueciSenhaPage />} />
            <Route path="/redefinir-senha" element={<RedefinirSenhaPage />} />
            <Route path="/change-password" element={
              <ChangePasswordRoute><ChangePasswordPage /></ChangePasswordRoute>
            } />
            <Route path="/" element={
              <PrivateRoute><Layout><DashboardPage /></Layout></PrivateRoute>
            } />
            <Route path="/tipos" element={
              <PrivateRoute><Layout><TiposPage /></Layout></PrivateRoute>
            } />
            <Route path="/ajuda" element={
              <PrivateRoute><Layout><AjudaPage /></Layout></PrivateRoute>
            } />
            <Route path="/livro-caixa" element={
            <PrivateRoute><Layout><LivroCaixaPage /></Layout></PrivateRoute>
            } />
            <Route path="/emprestimos" element={
              <PrivateRoute><Layout><EmprestimosPage /></Layout></PrivateRoute>
            } />
            <Route path="/historico" element={
              <PrivateRoute><Layout><HistoricoPage /></Layout></PrivateRoute>
            } />
            <Route path="/admin" element={
              <AdminRoute><Layout><AdminPage /></Layout></AdminRoute>
            } />
            <Route path="/super" element={
              <SuperAdminRoute><Layout><SuperAdminPage /></Layout></SuperAdminRoute>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
